import { render, staticRenderFns } from "./image-viewer.vue?vue&type=template&id=7f23f7a6&scoped=true&"
import script from "./image-viewer.vue?vue&type=script&lang=js&"
export * from "./image-viewer.vue?vue&type=script&lang=js&"
import style0 from "./image-viewer.vue?vue&type=style&index=0&id=7f23f7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23f7a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f23f7a6')) {
      api.createRecord('7f23f7a6', component.options)
    } else {
      api.reload('7f23f7a6', component.options)
    }
    module.hot.accept("./image-viewer.vue?vue&type=template&id=7f23f7a6&scoped=true&", function () {
      api.rerender('7f23f7a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DwElImage/src/image-viewer.vue"
export default component.exports